module.exports = __webpack_public_path__ + "img/semipublic.beb990fd.svg";